/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {OUSTIDE_CLICK_DIRECTIVES} from './index';
export class ClrOutsideClickModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [OUSTIDE_CLICK_DIRECTIVES], exports: [OUSTIDE_CLICK_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrOutsideClickModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrOutsideClickModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrOutsideClickModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
